import { PurchaseConfirmationDialog } from '@apps/guest/packages/layout-engine/widgets/Custom/components/TravelMap/components/PurchaseConfirmationDialog/PurchaseConfirmationDialog';
import { usePurchaseContextIdFromLocation } from '@apps/registry/common/utils/dropship';
import { Box, Flex, useDisclosure } from '@withjoy/joykit';
import React, { useEffect, useState } from 'react';
import { useHistory } from '@shared/core';
import { useHotelRoutePaths } from '../HotelBooking/HotelBooking.routes';

const NUITEE_BG_BIG = 'https://withjoy.com/assets/public/nuitee-clone-big.jpg';
const NUITEE_BG_SMALL = 'https://withjoy.com/assets/public/nuitee-bg-small.png';

export const AccommodationsOnRegistryConfirmation: React.FC<{ eventHandle: string; eventId: string }> = ({ eventHandle }) => {
  const [isPurchaseConfirmationOpen, setIsPurchaseConfirmationOpen] = useState(false);
  const history = useHistory();
  const hotelRoute = useHotelRoutePaths();
  const { isOpen: isPurchaseConfirmationDialogOpen, onClose: onPurchaseConfirmationClose } = useDisclosure({
    isOpen: isPurchaseConfirmationOpen,
    onClose: () => {
      history.push(hotelRoute.hotelSearch.buildRelativeUrl(eventHandle, { utm_medium: 'web', utm_source: 'confirmation_registry_purchase', utm_campaign: 'next_steps' }));
    }
  });

  const purchaseId = usePurchaseContextIdFromLocation();

  useEffect(() => {
    if (purchaseId) {
      // Clear the search param to prevent re-triggering
      setIsPurchaseConfirmationOpen(true);
    }
  }, [purchaseId]);

  return (
    <Flex justifyContent="center" alignItems="center" width="100vw">
      <Box as="img" width="100%" src={NUITEE_BG_SMALL} display={{ _: 'block', sm: 'none' }} />
      <Box as="img" width="100%" maxWidth={1000} src={NUITEE_BG_BIG} display={{ _: 'none', sm: 'block' }} />
      <PurchaseConfirmationDialog isOpen={isPurchaseConfirmationDialogOpen} onClose={onPurchaseConfirmationClose} />
    </Flex>
  );
};
